export default function MancalaIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="4" y="16" width="56" height="32" rx="16" fill="#3B434F" />
      <ellipse cx="13" cy="32" rx="5" ry="11" fill="#FF8A1F" />
      <ellipse cx="51" cy="32" rx="5" ry="11" fill="#2F8BFF" />
      <circle cx="25" cy="25" r="4.5" fill="#E7ECF3" />
      <circle cx="39" cy="25" r="4.5" fill="#E7ECF3" />
      <circle cx="25" cy="39" r="4.5" fill="#E7ECF3" />
      <circle cx="39" cy="39" r="4.5" fill="#E7ECF3" />
    </svg>
  );
}
